export const nameRE = /^\w[\w\s]{1,}$/;
export const emailRE = /^\w.+@\w+\.\w{2,5}$/;
export const mobileRE = /^[6-9]\d{9}$/;
export const usernameRE = /^\w{3,}$/;
export const passwordRE = /^.{4,}$/;
export const commaRE = /\B(?=(\d{3})+(?!\d))/g;